import React from "react";
import { CustomersListPage } from "../../../SharedPages/CustomersListPage/CustomersListPage";

/**
 * The "Customers" page that displays a list of customers.
 */
export function SellerAdminCustomersList() {
  return <CustomersListPage />;
}
